import type { VignetteDefinition } from "./types";

/** A common activity — Johnny jogging along the beach, reusing the sourced animation library's "Run" clip directly (a good fit, unlike Interact/Wave standing in elsewhere). */
export const joggingVignette: VignetteDefinition = {
  id: "jogging",
  name: "Jogging along the beach",
  category: "common",
  weight: 8,
  animationClip: "Run",
  loopAnimation: true,
  durationMs: 5000,
  cameraFraming: {
    offset: { x: 3, y: 1.6, z: 0 },
    targetOffset: { x: 0, y: 1, z: 0 },
  },
  audioCues: [],
  timeOfDay: "day",
};
